import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const rows = [['Ore perse a pianificare ogni lezione da zero', 'Sessioni pronte da adattare al tuo Studio'], ['Esercizi ripetuti sul Mat o Reformer', '150+ esercizi e nuove sequenze'], ['Gruppi misti difficili da gestire', 'Variazioni chiare per ogni livello'], ['Incertezza con esigenze specifiche', 'Protocolli clinici e popolazioni speciali'], ['Entrare in Studio senza un piano', '6 volumi per insegnare con metodo']];
export function FinalCTA() {
  return <section className="border-y-4 border-emerald-400 bg-[#241622] px-5 py-20" data-id="element-38" data-mp="vwuk78qpl2le">
      <div className="mx-auto max-w-3xl text-center" data-id="element-39" data-mp="qw6wox1ov3vx">
        <h2 className="font-display text-4xl font-bold uppercase leading-none text-white sm:text-6xl" data-id="element-40" data-mp="14v6hftm2yymt">
          Smetti di improvvisare.{' '}
          <span className="text-emerald-300" data-id="element-41" data-mp="zxxznu4ugwm3">
            Inizia a insegnare con un sistema.
          </span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-medium leading-relaxed text-slate-300" data-id="element-42" data-mp="2c6rbsam3yip6">
          Unisciti a oltre 1500 insegnanti di Pilates che pianificano l’intero
          anno in meno di 5 minuti.
        </p>
        <p className="mt-5 text-xs font-bold uppercase tracking-[.18em] text-emerald-200" data-id="element-43" data-mp="2r1xfgqxqe5fc">
          Sessioni · Esercizi · Progressioni · Reformer · Matwork · Tutto
          organizzato
        </p>
        <div className="mt-10 overflow-hidden border border-emerald-300/30 text-left" data-id="element-44" data-mp="302lvtsalkhve">
          <div className="grid grid-cols-2 bg-[#38233c] text-center text-[10px] font-bold uppercase tracking-widest" data-id="element-45" data-mp="30092yk3awn3k">
            <p className="p-4 text-slate-300" data-id="element-46" data-mp="39s5fv1a1qhru">Senza Pilates Pronta</p>
            <p className="border-l border-emerald-300/30 p-4 text-emerald-300" data-id="element-47" data-mp="39uht514v03yk">
              Con Pilates Pronta
            </p>
          </div>
          {rows.map(([without, withSystem]) => <div key={without} className="grid grid-cols-2 border-t border-emerald-300/20 text-xs sm:text-sm" data-id="element-48" data-mp="3itd40qium287">
              <p className="flex gap-2 p-4 font-medium text-slate-300" data-id="element-49" data-mp="1eq1ok4bekreu">
                <span className="text-rose-400" data-id="element-50" data-mp="1sgn9rzobxdfw">×</span>
                {without}
              </p>
              <p className="flex gap-2 border-l border-emerald-300/20 bg-emerald-300/5 p-4 font-semibold text-white" data-id="element-51" data-mp="1npyjuosasoiv">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-emerald-300" data-id="element-52" data-mp="22ebenifng1bs" />
                {withSystem}
              </p>
            </div>)}
        </div>
        <div className="my-9" data-id="element-53" data-mp="1xi4c7zmgp7yl">
          <CountdownTimer dark data-id="element-54" data-mp="2bfsur0t2430h" />
        </div>
        <div className="border-2 border-emerald-400 bg-[#38233c] p-7 text-left" data-id="element-55" data-mp="2beq1im89hohe">
          <p className="text-xs font-bold uppercase tracking-widest text-emerald-300" data-id="element-56" data-mp="27efnqne89trz">
            Pacchetto completo
          </p>
          <h3 className="mt-2 text-xl font-bold text-white" data-id="element-57" data-mp="h3bc66j5xr26">
            PILATES PRONTA™ — 6 Volumi + 5 Bonus
          </h3>
          <div className="mt-5 flex items-end justify-between" data-id="element-58" data-mp="2vg5rsk4cb6o">
            <div data-id="element-59" data-mp="2y2moiswg31k">
              <p className="text-sm font-bold text-slate-300 line-through" data-id="element-60" data-mp="6xjtbfk2b68b">
                €106
              </p>
              <p className="font-display text-6xl font-bold leading-none text-white" data-id="element-61" data-mp="3pc2j4ys84tu0">
                €19
              </p>
            </div>
            <p className="bg-emerald-400 px-3 py-2 text-xs font-bold uppercase text-[#241322]" data-id="element-62" data-mp="3u92rxhggkaot">
              Risparmi €87
            </p>
          </div>
        </div>
        <a href="https://pilates-pronta.impultienda.ar/checkout" className="cta-button mt-8 block w-full rounded-2xl px-5 py-5 text-lg font-bold sm:text-xl" data-id="element-63" data-mp="3kcpxghd39st0">
          SCARICA IL MEGAPACK COMPLETO A €19
        </a>
        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-64" data-mp="3bc1j1ljs9qfl">
          <span className="flex gap-1" data-id="element-65" data-mp="14jh8b2z8gtfi">
            <LockKeyholeIcon className="h-4 w-4 text-emerald-300" data-id="element-66" data-mp="19koi17kxs2ot" />
            Pagamento sicuro
          </span>
          <span className="flex gap-1" data-id="element-67" data-mp="35mhzg5o0ceza">
            <ZapIcon className="h-4 w-4 text-emerald-300" data-id="element-68" data-mp="35l6zyi1lhtdz" />
            Accesso immediato
          </span>
          <span className="flex gap-1" data-id="element-69" data-mp="30mn8y3859rer">
            <ShieldCheckIcon className="h-4 w-4 text-emerald-300" data-id="element-70" data-mp="2voc281d5bx0r" />
            Garanzia 7 giorni
          </span>
        </div>
      </div>
    </section>;
}